// Copyright (c) 2017 Deere & Company

import adjustmentTypes from './adjustment-types';
import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import debit from './debit';
import isConfirmationModalVisible from './confirmation-modal';
import isPartialDebitModalVisible from './partial-debit-modal';

export const getCombinedReducers = () => combineReducers({
    adjustmentTypes,
    busyCounter,
    debit,
    isConfirmationModalVisible,
    isPartialDebitModalVisible
});



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/reducers/index.js